import React from 'react';
import { useTestPlaybookDrawerContext } from 'app/playbook-editor/transform-drawer/TestPlaybookDrawerContextProvider';
import AdvancedOutputTab from 'app/playbook-editor/transform-drawer/DrawerTabsSection/AdvancedOutputTab';

export default function PipelineOutputTab() {
  const {
    chainState: { pipelineOutput },
  } = useTestPlaybookDrawerContext();

  // A never-deployed pipeline makes this stage a passthrough — name that for
  // the user, since the output looks identical to a light transform.
  const infoAlert = pipelineOutput.passthrough
    ? 'The selected pipeline has no deployed pipeline-level transforms or filters — the event passed through this stage unchanged.'
    : 'Reflects the deployed pipeline configuration.';

  return (
    <AdvancedOutputTab
      output={pipelineOutput}
      trackingEventName="editor_test_pipeline_output_viewed"
      infoAlert={infoAlert}
    />
  );
}
